import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class LoadingService {
  // Observable bool source
  private loadingState = new Subject<boolean>();

  // Observable bool stream
  loading$ = this.loadingState.asObservable();

  constructor() {}

  // method to set loading state
  setLoadingState(value: boolean) {
    this.loadingState.next(value);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/services/loading.service.ts